import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: spacing(75),
    width: '100%',
    padding: spacing(0, 20),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  main: {
    width: '100%',
    maxWidth: '100% !important',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    padding: '0 !important',
    position: 'relative',
    height: `calc(100vh - 150px)`,
    maxHeight: `calc(100vh - 150px)`,
  },
  title: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontSize: `${Theme.Typography.FontSize.Large}px`,
    lineHeight: '112.5%',
    color: Theme.Colors.Grayscale.OneThousand,
  },
  buttonWrapper: {
    width: '160px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  modal: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectWrapper: {
    display: 'flex',
    width: '100%',
    height: 'fit-content',
    justifyContent: 'center',
    marginTop: '30px',
  },
  selectTitle: {
    fontSize: '20px',
  },
  dialogContent: {
    padding: `${spacing(40)} !important`,
  },
}))
